import { motion } from "framer-motion";

const steps = [
  ["Learn", "Understand the problem, principles, and language before making major decisions."],
  ["Build", "Organize the current financial picture and identify where control, liquidity, growth, income, protection, and legacy need attention."],
  ["Implement", "Put appropriate tools and strategies in place only after their purpose is understood."],
  ["Track", "Keep the system visible, organized, and measurable as policies, loans, repayments, and family goals evolve."],
  ["Improve", "Review progress, adapt to changes, strengthen financial habits, and continue expanding the system over time."],
];

export const ClientJourneySection = () => (
  <section id="process" data-testid="client-journey-section" className="section-lr bg-[#FBF8F1]">
    <div className="container-lr">
      <div className="max-w-3xl">
        <div className="flex items-center gap-4"><span className="gold-rule" /><p className="eyebrow">The Coaching Experience</p></div>
        <h2 className="section-heading mt-6 text-legacy">A <span className="accent-word">financial system</span> is built, implemented, and improved over time.</h2>
        <p className="mt-5 text-base leading-relaxed text-slate md:text-lg">The value is not simply choosing financial tools. The value is understanding why each decision is being made, where it fits, and how to keep the system moving in the right direction.</p>
      </div>

      <ol className="relative mt-16 grid gap-8 lg:grid-cols-5 lg:gap-6">
        {/* Desktop horizontal connector line */}
        <span aria-hidden="true" className="absolute left-6 right-6 top-6 hidden h-px bg-gradient-to-r from-gold/25 via-gold/70 to-gold/25 lg:block" />
        {steps.map(([title, copy], index) => (
          <motion.li
            key={title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
            className="relative flex gap-4 lg:flex-col lg:gap-0"
          >
            {/* Mobile vertical connector line */}
            {index < steps.length - 1 && (
              <span aria-hidden="true" className="absolute left-6 top-14 h-[calc(100%+2rem-3.5rem)] w-px bg-gold/40 lg:hidden" />
            )}
            <span className="relative z-10 inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold/50 bg-ivory font-serif text-lg text-bronze shadow-[0_0_0_6px_#FBF8F1]">
              {index + 1}
            </span>
            <div className="lg:mt-6">
              <h3 className="font-serif text-xl leading-tight text-legacy lg:text-2xl">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate">{copy}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
